import qs from 'qs'

const fields = [
]

export const queryEssayEntryThumbnails = (options: QueryManyOptions) => {
  const sortKey = strapiGetI18nSortKey(options?.locale, 'titles.i18n_string')

  const query = qs.stringify(
    {
      publicationState: options?.publicationState || 'live',
      sort: options?.sort || [`${sortKey}:asc`],
      pagination: {
        page: options?.page || 1,
        pageSize: options?.pageSize || 3,
      },
      fields,
      populate: {
        ...queryFragmentCollectionTypeDefault,
        blocks: {
          ...queryFragmentBlocksText
        },
        cover_image: true,
        authors: true
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `essay-entries?${query}`
}
